import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placeServicePaymentsService = {
  // Retorna os pagamentos aceitos por um PlaceService específico
  // Rota: GET /api/places/{placeId}/services/{serviceId}/payments
  getByPlaceServiceId: async (placeServiceId) => {
    // Precisamos extrair placeId e serviceId do placeService
    // Por enquanto vamos usar a rota direta se a API suportar
    const response = await api.get(`/placeservices/${placeServiceId}/payments`);
    return extractData(response.data);
  },

  // Retorna os pagamentos de um serviço em um local (rota nested correta)
  // Rota: GET /api/places/{placeId}/services/{serviceId}/payments
  getByPlaceAndService: async (placeId, serviceId) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}/payments`);
    return extractData(response.data);
  },

  // Buscar payment específico por ID
  // Rota: GET /api/places/{placeId}/services/{serviceId}/payments/{paymentId}
  getById: async (placeId, serviceId, paymentId) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}/payments/${paymentId}`);
    return extractData(response.data);
  },

  // Criar novo pagamento para um PlaceService
  // Rota: POST /api/places/{placeId}/services/{serviceId}/payments
  // Body: { paymentId, defaultPrice }
  create: async (data) => {
    const { placeId, serviceId, paymentId, defaultPrice } = data;
    const response = await api.post(`/places/${placeId}/services/${serviceId}/payments`, {
      paymentId,
      defaultPrice
    });
    return extractData(response.data);
  },

  // Atualizar pagamento existente
  // Rota: PUT /api/places/{placeId}/services/{serviceId}/payments/{paymentId}
  // Body: { defaultPrice }
  update: async (id, data) => {
    const { placeId, serviceId, defaultPrice } = data;
    const response = await api.put(`/places/${placeId}/services/${serviceId}/payments/${id}`, {
      defaultPrice
    });
    return extractData(response.data);
  },

  // Deletar pagamento
  // Rota: DELETE /api/places/{placeId}/services/{serviceId}/payments/{paymentId}
  delete: async (placeId, serviceId, paymentId) => {
    const response = await api.delete(`/places/${placeId}/services/${serviceId}/payments/${paymentId}`);
    return response.data;
  },
};

export default placeServicePaymentsService;
